/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
var _a;
const loggerDefaults = {
    level: 'local',
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
};
const logger = (_a = globalThis.njDebug) !== null && _a !== void 0 ? _a : loggerDefaults;

export { logger };
